import React, { useEffect, useState } from 'react';
export function StickyBanner() {
  const [tomorrowDate, setTomorrowDate] = useState('');
  useEffect(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const options: Intl.DateTimeFormatOptions = {
      month: 'long',
      day: 'numeric'
    };
    setTomorrowDate(tomorrow.toLocaleDateString('en-US', options));
  }, []);
  if (!tomorrowDate) return null;
  return <div className="fixed top-0 left-0 w-full bg-crimson text-white text-center py-2.5 px-4 z-50 font-inter text-xs md:text-sm font-bold tracking-wide shadow-md" data-id="element-58">
      ⚠️ ATTENTION: Price increase scheduled for {tomorrowDate}
    </div>;
}